import { render, staticRenderFns } from "./NewsFeaturesList.vue?vue&type=template&id=3e8b7abe"
import script from "./NewsFeaturesList.js?vue&type=script&lang=js&external"
export * from "./NewsFeaturesList.js?vue&type=script&lang=js&external"
import style0 from "./NewsFeaturesList.vue?vue&type=style&index=0&id=3e8b7abe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports